import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0669e8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-title-block" }
const _hoisted_2 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'wrap-title',
  props: {
  /** Заголовок  */
  text: {
    type: String,
    default: "",
  },
  /** Подзаголовок */
  size: {
    type: String,
    default: "medium",
  },
  weight: {
    type: String,
    default: "800",
  },
},
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([[__props.size], "title-block"]),
      style: _normalizeStyle({'font-weight':__props.weight })
    }, [
      _createElementVNode("div", {
        class: "entity-title",
        innerHTML: __props.text
      }, null, 8, _hoisted_2)
    ], 6)
  ]))
}
}

})